import React , {useState, useImperativeHandle, forwardRef} from 'react'
import {Modal, Button} from 'antd'
import {WWTable} from "@/globalComponents";
import {WWUtils} from "../../tools";
function BatchCheckModal(props,ref) {
    const [visible,setVisible] = useState(false)
    const [dataSource,setDataSource] = useState([])
    const [successLength,setSuccessLength] = useState(0)
    useImperativeHandle(ref, () => ({
        showModal: (data,successDevices) => {
            setVisible(true)
            let newData = []
            data.map(function (item) {
                item.errorData.map(function (carCode) {
                    newData.push({
                        carCode,
                        errorMessage:item.errorMessage
                    })
                })
            })
            setDataSource(newData)
            setSuccessLength(successDevices.length)
        },
    }));

    function hideModal() {
        setVisible(false)
        setDataSource([])
        setSuccessLength(0)
    }
    
    function submit() {
        let carCode = []
        dataSource.forEach(function (item) {
            carCode.push(item.carCode)
        })
        WWUtils.copy(carCode.join(','))
        props.handleImeiSet && props.handleImeiSet({
            target:{
                value:carCode.join('\n')
            }
        })
        setVisible(false)
    }

    const columns = [{
        title: Strings.carCode || "机械编号",
        dataIndex: 'carCode',
        width: '50%',

    }, {
        title: Strings.errorMessage || "失败原因",
        dataIndex: 'errorMessage',
        width: '50%'
    }]

    return <Modal transitionName=""  maskTransitionName=""
                  className="default_modal wid650"
                  width={800}
                  visible={visible}
                  onCancel={hideModal} maskClosable={false}
                  title={Strings.tips || "提示"} footer={null}>
            <div className="maps-api-tip column mgb15">
                <div>{Strings.success1 || "成功："}<span className="green">{successLength}</span>&nbsp;&nbsp;
                    {Strings.fail1 || "失败："}<span className="red">{dataSource.length}</span></div>
                  <div>{Strings.failTips || "以下车辆操作失败点击确定，成功车辆将正常操作，失败车辆则复制并回填至输入框"}</div>
            </div>
        <WWTable  className={"new_app_table"} 
                  hideShadow={true} columns={columns}
                  innerHeight={350} height={0}
                  dataSource={dataSource}  pagination={false} 
                  hiddenPagination={true}/>
        <div className="modal_item modal_btns mgt24">
            <Button className="" onClick={hideModal}>{Strings.cancel || "取消"}</Button>
            <Button className={"mgl10"} type='primary' onClick={submit}>{Strings.sure || "确定"}</Button>
        </div>
    </Modal>
}
export default forwardRef(BatchCheckModal)